import http from './reddit'
import qs from 'qs'
// assortLedger
export default {
    // 分类帐玩法列表
    assortLedgerReport: (data) => {
        let obj = JSON.parse(JSON.stringify(data))
        Object.keys(obj).forEach(it => {
            if (!obj[it]) delete obj[it]
        })
        let str = qs.stringify(obj, { encode: false })
        return http.Get(`${http.url.Newcommon}/${data.repnum == 1 ? 'linkreport1' : 'linkreport2_14'}?${str}`)
    },
}